import {
    Box,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    SwipeableDrawer,
} from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { makeStyles } from "@material-ui/styles";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { firebaseConnect, isLoaded, useFirebase } from "react-redux-firebase";
import { useHistory } from "react-router";
import { RootState } from "redux/model";
import Navbar from "ui/componentes/Sidebar/Navbar/Navbar";
import SidebarProfile from "ui/componentes/Sidebar/SidebarProfile/SidebarProfile";

const useStyles = makeStyles((theme) => ({
    drawerPaper: {
        minWidth: 210,
        maxWidth: 260
    },
    cursor: {
        cursor: "pointer",
    },
}));

interface SidebarProps {
    open: boolean;
    onClose: any;
}

const Sidebar: FC<SidebarProps> = ({ open, onClose }) => {
    firebaseConnect();
    const classes = useStyles();
    const history = useHistory();
    const firebase = useFirebase();
    const auth = useSelector((state: RootState) => state.firebase.auth);

    return (
        <SwipeableDrawer
            open={open}
            onClose={onClose}
            onOpen={() => false}
            classes={{
                paper: classes.drawerPaper,
            }}
        >
            <Box display="flex" flexDirection="column" height="100%">
                <Box flexGrow={1}>
                    <div
                        className={classes.cursor}
                        onClick={() => {
                            history.push("/profile");
                            onClose();
                        }}
                    >
                        <SidebarProfile />
                    </div>
                    <Divider />
                    <Navbar onClickItem={onClose} />
                </Box>
                {isLoaded(auth) && (
                    <List>
                        <ListItem
                            button
                            onClick={() => {
                                firebase.logout().then(() => onClose());
                            }}
                        >
                            <ListItemIcon>
                                <ExitToAppIcon />
                            </ListItemIcon>
                            <ListItemText primary="Logout" />
                        </ListItem>
                    </List>
                )}
            </Box>
        </SwipeableDrawer>
    );
};

export default Sidebar;
